<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="full"
      :confirm-loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>添加运营日志</span>
    </template>
    <template #content>
      <el-form
          ref="form"
          inline
          :model="form">
        <gj-area-title>商品维度</gj-area-title>
        <el-form-item
            label="商品维度"
            label-width="77px">
          <el-radio-group
              v-model="form.dimension">
            <el-radio
                v-for="item in OperationLogEnum.dimensionOption"
                :key="item.id"
                :label="item.id">
              {{item.text}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 表格 -->
        <gj-area-title>商品</gj-area-title>
        <app-asin-operation-log-picker
            v-if="form.dimension === OperationLogEnum.dimension.ASIN"
            :form="form"
        ></app-asin-operation-log-picker>
        <app-variation-asin-operation-log-picker
            v-if="form.dimension === OperationLogEnum.dimension.VARIATION_ASIN"
            :form="form"
        ></app-variation-asin-operation-log-picker>
        <!-- 日志内容 -->
        <gj-area-title style="margin: 20px 0 15px;">日志信息</gj-area-title>
        <app-operation-log-content-picker
            ref="contentPicker"
            :form="form"
        ></app-operation-log-content-picker>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin} from "@/minxins";
  import {OperationLogEnum} from "../../common/enum";
  import AppAsinOperationLogPicker from "./components/asin-operation-log-picker";
  import AppOperationLogContentPicker from "./components/operation-log-content-picker";
  import AppVariationAsinOperationLogPicker from "./components/variation-asin-operation-log-picker";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {addBatchOperationLog} from "../../../../../../api/sale";
  import {responseMixin} from "../../../../../../minxins";

  export default {
    name: "app-add-operation-log-modal",
    components: {AppVariationAsinOperationLogPicker, AppOperationLogContentPicker, AppAsinOperationLogPicker},
    mixins: [modalMixIn, queryMixin, responseMixin],
    props: {
    },
    data() {
      return {
        form: {
          dimension: OperationLogEnum.dimension.ASIN,
          asinItems: [],
          variationAsinItems: [],
          contentItems: []
        },
        OperationLogEnum: OperationLogEnum
      }
    },
    watch: {
      'form.dimension': {
        handler: function (dimension) {
          if (dimension === OperationLogEnum.dimension.ASIN) {
            this.form.variationAsinItems = [];
          } else {
            this.form.asinItems = [];
          }
        },
        immediate: true
      }
    },
    methods: {
      confirm() {
        if (this.formValidate()) {
          const params = {
            dimension: this.form.dimension,
            operationLogList: this.form.contentItems.map(item => ({
              type: item.type,
              logDate: convertToDate(item.date),
              content: item.content
            }))
          };
          if (this.form.dimension === OperationLogEnum.dimension.ASIN) {
            params.listingList = this.form.asinItems.map(item => ({
              asin: item.asin,
              countryCode: item.countryCode,
              marketId: item.marketId,
            }));
          } else {
            params.listingList = this.form.variationAsinItems.map(item => ({
              variationAsin: item.variationAsin,
              countryCode: item.countryCode,
              marketId: item.marketId,
            }));
          }
          this.confirmLoading = true;
          addBatchOperationLog(params)
            .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success('创建成功');
                   this.$emit('created');
                   this.$gjDestroy();
                });
            })
            .complete(() => this.confirmLoading = false);
        }
      },
      formValidate() {
        if ((this.form.dimension === OperationLogEnum.dimension.ASIN && this.form.asinItems.length === 0)
          || (this.form.dimension === OperationLogEnum.dimension.VARIATION_ASIN && this.form.variationAsinItems.length === 0)) {
          this.$gjMessage.error('请选择商品');
          return false;
        }
        if (!this.$refs.contentPicker.$gjFormValidate()) {
          this.$gjMessage.error('日志信息请填写完整');
          return false;
        }
        return true;
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
  /deep/ .vxe-table--empty-placeholder{
    top: 38% !important;
  }
</style>

